/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.detail.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions'
])

.controller('ResourcesDetailController', ['$scope', '$state', '$log', 'ApiService', 'HelpersService', 'PermissionsService', function($scope, $state, $log, ApiService, HelpersService, PermissionsService) {

  $scope.resourcesDetail = {

    templateId: -1,
    showErrors: false,
    isLoading: false,
    isLoaded: false,

    entityType: '',

    model: {},

    assignmentColumns: [],
    assignedResources: [],
    selectedAssignedResources: [],

    errors: [],

    init: function() {
      this.entityType = HelpersService.getEntityName($state.params.type);

      $scope.$emit('Application::contentTitleChange', {
        title: 'Resource Template',
        buttonLeft: {
          label: '< Back',
          action: function() {
            window.history.go(-1);
          }
        }
      });

      if ($state.params.hasOwnProperty('id')) {
        this.templateId = $state.params.id;
        this.getDetail(this.templateId);
      }
    },


    hasModelFields: function() {
      return (this.model.fields instanceof Array && this.model.fields.length > 0);
    },

    hasAssignedResources: function() {
      return (this.assignedResources instanceof Array && this.assignedResources.length > 0);
    },

    getUpdatePermission: function() {
      return 'ENTITY_TEMPLATE_' + this.entityType.singular.toUpperCase() + '_UPDATE';
    },

    getDetail: function(id) {
      ApiService.resource.detail(id).then(this.success.getDetail, this.error.getDetail);
    },

    getAssigned: function(id) {
      ApiService.resource.instances.list(id).then(this.success.getAssigned, this.error.getAssigned);
    },

    getResourceCategory: function() {
      var r = this.model.resourceCategory;
      return r;
    },

    processResources: function(resources) {

      var i, ii,
        j, jj,
        row = {},
        processed = [],
        cols = [{
          field: 'name',
          displayName: 'Name',
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })">{{ COL_FIELD }}</a></div>'
        }];

      for (i=0,ii=resources.length;i<ii;i++) {
        row = {
          id: resources[i].id,
          name: resources[i].name
        };

        if (i === 0 && resources[i].resourceCategory === 'Personnel') {
          cols[0].cellTemplate = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.users.detail({ id: \'{{ row.entity.id }}\' })">{{ COL_FIELD }}</a></div>';
        }

        if (resources[i].fields instanceof Array) {
          for (j=0,jj=resources[i].fields.length;j<jj;j++) {
            row['id_' + resources[i].fields[j].fieldOrder] = HelpersService.getFieldValue(resources[i].fields[j], true) || '-';
            if (i===0) {
              cols.push({
                field: 'id_' + resources[i].fields[j].fieldOrder,
                displayName: resources[i].fields[j].name
              });
            }
            console.log('ResourcesDetailController::processResources -> rowUser', row['id_' + resources[i].fields[j].fieldOrder]);
          }
        }

        processed.push(row);
      }

      $scope.resourcesDetail.assignmentColumns = cols;

      console.log('ResourcesDetailController::processResources', processed);
      return processed;
    },

    success: {
      getDetail: function(response, status, headers, config) {
        var self = $scope.resourcesDetail;

        self.showErrors = false;
        self.model = response.data.resourceType;
        self.entityType = HelpersService.getEntityName(self.model.resourceCategory);

        if (!PermissionsService.check('ENTITY_TEMPLATE_'+self.entityType.singular.toUpperCase()+'_VIEW')) {
          $state.go('home.default', {}, { notify: true });
        }

        $scope.$emit('Application::contentTitleChange', {
          title: 'Resource Template',
          buttonLeft: {
            label: '< Back',
            action: function() {
              window.history.go(-1);
            }
          },
          buttonRight: {
            label: 'Edit Template',
            permissions: 'ENTITY_TEMPLATE_' + self.entityType.singular.toUpperCase() + '_UPDATE',
            action: function() {
              $state.go('application.resources.edit', { id: $scope.resourcesDetail.templateId });
            }
          }
        });

        self.getAssigned(response.data.resourceType.id);
      },

      getAssigned: function(response) {
        var self = $scope.resourcesDetail;
        self.assignedResources = $scope.resourcesDetail.processResources(response.data.payload);
        self.isLoaded = true;
      }
    },

    error: {
      getDetail: function(response, status, headers, config) {
        if (response.status === 403) {
          $state.go('home.default', {}, { notify: true });
        }

        $scope.resourcesDetail.showErrors = true;
        $scope.resourcesDetail.errors = [{
          message: "There was a problem getting template"
        }];
      },

      getAssigned: function(response) {}

    }

  };

  $scope.assignedResourcesGridOptions = {
    paginate: true,
    pageSize: 50,
    selectedItems: $scope.resourcesDetail.selectedAssignedResources
  };

  $scope.resourcesDetail.init();

}]);